import { render, staticRenderFns } from "./SessionAddCourse.vue?vue&type=template&id=12c89d00&scoped=true&"
import script from "./SessionAddCourse.vue?vue&type=script&lang=js&"
export * from "./SessionAddCourse.vue?vue&type=script&lang=js&"
import style0 from "./SessionAddCourse.vue?vue&type=style&index=0&id=12c89d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c89d00",
  null
  
)

export default component.exports